import React from "react";
import { connect } from "react-redux";


const PlanDetailsTable = ({ displayDetail, ...props }) => {
  return (
    <div class="container-planDetail fit-content">
      {displayDetail && displayDetail.map((detail) => {
        return (
          <div class="container-Cambia w-1140px">
            <div>
              <h6 class="pres-drug">{detail.name}</h6>
            </div>
            {detail.value.map((prescriptionTierObj, index) => {
              return (
                <div>
                  <div class="container-Cambia display-flex">
                    <div class="container-Cambia display-flex fit-content">
                      <div class="w-160px">
                        <h6>{prescriptionTierObj.tier}</h6>
                      </div>
                      <div class="container-Cambia display-flex mtop-0-detailspage">
                        <div class="display-inline">
                          <h6 class="h50">One-month Supply</h6>
                          <h6 class="h50">Three-Month Supply</h6>
                        </div>
                        <div class="container-Cambia display-inline mtop-0-detailspage" >
                          <div class="container-Cambia display-flex fit-content mtop-0-detailspage">
                            {prescriptionTierObj.oneM.map((cost) => {
                              return (
                                <div class="container-Cambia mtop-0-detailspage">
                                  <p class="h50">{cost}</p>
                                </div>
                              );
                            })}
                          </div>
                          <div class="container-Cambia display-flex fit-content">
                            {prescriptionTierObj.threeM.map((cost) => {
                              return (
                                <div class="container-Cambia">
                                  <p class="h50">{cost}</p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {index !== detail.value.length - 1 && (
                    <hr class="hr-w95"/>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    // cardDetails: state.webApp.planCardData,
  };
};
const mapDispatchToProps = {
  //   setFormData
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanDetailsTable);
